module.exports = __webpack_public_path__ + "static/media/facebook.bd09a7e8.svg";